import { WSMutationConfig } from "@ws-react-query";
import { IRateCard } from "@wingspanhq/payments/dist/interfaces";
import { IRateCardCreateRequest } from "@wingspanhq/payments/dist/interfaces/api";
import { createRateCard } from "../../../services/rateCards/createRateCard";
import { updatePayeeEngagementByPayeeId } from "../../../services/payeeEngagement/updatePayeeEngagementByPayeeId";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";
import {
  QUERY_PAYEE_ENGAGEMENT_RATE_CARD_BY_PAYEE,
  QUERY_RATE_CARD
} from "../keys";

type CreateRateCardOverrideParams = {
  payeeId: string;
  payeeEngagementId: string;
  rateCardData: IRateCardCreateRequest;
  orgPayerId?: string;
};

export const useMutationCreateRateCardOverride = (
  config?: WSMutationConfig<IRateCard, WSServiceError>
) =>
  useWSMutation(
    async ({
      payeeId,
      payeeEngagementId,
      rateCardData,
      orgPayerId
    }: CreateRateCardOverrideParams) => {
      // 1. Create new rate card
      const newRateCard = await createRateCard(rateCardData);

      // 2. Link it to PayerPayeeEngagement
      await updatePayeeEngagementByPayeeId(
        payeeId,
        payeeEngagementId,
        {
          payerOwnedData: {
            rateCardId: newRateCard.rateCardId
          }
        },
        orgPayerId
      );

      return newRateCard;
    },
    {
      ...config,
      dependencies: [QUERY_PAYEE_ENGAGEMENT_RATE_CARD_BY_PAYEE, QUERY_RATE_CARD]
    }
  );
